import TopicsFinder from "./TopicsFinder"; // Основной компонент

export default TopicsFinder; // Экспорт по умолчанию